import { Routes } from '@angular/router';

import { activiteResolver } from './_helpers/activite.resolver';
import { AuthGuard } from './_helpers/auth.guard';
import { blocResolver } from './_helpers/bloc.resolver';
import { canDeactivateGuard } from './_helpers/can-deactivate.guard';
import { cartographieResolver } from './_helpers/cartographie.resolver';
import { certificationResolver } from './_helpers/certification.resolver';
import { etapeResolver } from './_helpers/etape.resolver';
import { finParcoursResolver } from './_helpers/fin-parcours.resolver';
import { groupeÉtapesResolver } from './_helpers/groupe-étapes.resolver';
import { moduleResolver } from './_helpers/module.resolver';
import { parcoursResolver } from './_helpers/parcours.resolver';
import { referentielResolver } from './_helpers/referentiel.resolver';
import { scenarisationResolver } from './_helpers/scenarisation.resolver';
import { siteResolver } from './_helpers/site.resolver';
import { séquenceResolver } from './_helpers/séquence.resolver';
import { AccèsRestreintComponent } from './accès-restreint/accès-restreint.component';
import { GestionCertificationList } from './administration/gestion-certification/list/gestion-certification-list.component';
import { ParcoursListComponent } from './administration/gestion-parcours/list/parcours-list.component';
import { RéférentielsListComponent } from './administration/gestion-référentiels/list/referentiels-list.component';
import { GestionSitesComponent } from './administration/gestion-sites/components/list/gestion-sites.component';
import { GestionTrigrammesTypeCertificationList } from './administration/gestion-trigramme-certification/list/gestion-trigramme-certification-list.component';
import { MessagesInformationComponent } from './administration/messages-information/messages-information.component';
import { TechniqueAnimationListComponent } from './administration/technique-animation/technique-animation-list/technique-animation-list.component';
import { AptitudesComponent } from './bloc-competences/aptitudes/aptitudes.component';
import { BlocCompetencesComponent } from './bloc-competences/bloc-competences.component';
import { GestionComponent } from './bloc-competences/components/gestion/gestion.component';
import { CartoListComponent } from './cartographie/list/carto-list.component';
import { CatalogueNationalComponent } from './catalogue-national/catalogue-national.component';
import { CroisementRéférentielFormComponent } from './croisement-référentiel/form/croisement-référentiel-form.component';
import { CroisementRéférentielListComponent } from './croisement-référentiel/list/croisement-référentiel-list.component';
import { FormationObligatoireReglementaireComponent } from './formation-obligatoire-reglementaire/formation-obligatoire-reglementaire.component';
import { ActiviteLayoutComponent } from './layouts/activite-layout/activite-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { CartoLayoutComponent } from './layouts/carto-layout/carto-layout.component';
import { CroisementLayoutComponent } from './layouts/croisement-layout/croisement-layout.component';
import { OffreRegionaleLayoutComponent } from './layouts/offre-régionale-layout/offre-regionale-layout.component';
import { ParcoursLayoutComponent } from './layouts/parcours-layout/parcours-layout.component';
import { ScenarisationLayoutComponent } from './layouts/scenarisation-layout/scenarisation-layout.component';
import { ModalitésComponent } from './modalités/modalités.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SélectionOffreRégionaleComponent } from './offre-regionale/form/sélection-offre-régionale/sélection-offre-régionale.component';
import { OffreRegionaleComponent } from './offre-regionale/offre-regionale.component';
import { RéférentielMétierParcoursComponent } from './référentiel-métier-parcours/référentiel-métier-parcours.component';
import { FormLayoutComponent } from './référentiel-métier/layouts/form-layout/form-layout.component';
import { ReferentielMetierInterrelationsComponent } from './référentiel-métier/référentiel-metier-interrelations/referentiel-metier-interrelations.component';
import { RéférentielMétierGénéralComponent } from './référentiel-métier/référentiel-métier-général/référentiel-métier-général.component';
import { RéférentielMétierProcessusComponent } from './référentiel-métier/référentiel-métier-processus/référentiel-métier-processus.component';
import { RéférentielMétierPérimètreComponent } from './référentiel-métier/référentiel-métier-périmètre/référentiel-métier-périmètre.component';
import { RéférentielMétierRessourcesProfessionnellesComponent } from './référentiel-métier/référentiel-métier-ressources-professionnelles/référentiel-métier-ressources-professionnelles.component';
import { ActiviteFormComponent } from './scénarisation/activité-form/activite-form.component';
import { ActiviteAlternativesComponent } from './scénarisation/activité/activité-alternatives/activite-alternatives.component';
import { ActiviteDescriptionComponent } from './scénarisation/activité/activité-description/activite-description.component';
import { ActiviteParcoursObjectifComponent } from './scénarisation/activité/activité-parcours-objectif/activite-parcours-objectif.component';
import { SequenceListComponent } from './scénarisation/séquence-list/sequence-list.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      { path: '', component: CartoLayoutComponent },
      {
        path: 'cartographies',
        children: [
          {
            path: '',
            component: CartoLayoutComponent,
            pathMatch: 'full',
          },
          {
            path: ':slugCarto/catalogue-national',
            resolve: {
              cartographie: cartographieResolver,
            },
            component: OffreRegionaleLayoutComponent,
            children: [
              {
                path: '',
                component: CatalogueNationalComponent,
              },
            ],
          },
          {
            path: ':slugCarto/offre-régionale',
            resolve: {
              cartographie: cartographieResolver,
            },
            component: OffreRegionaleLayoutComponent,
            children: [
              {
                path: '',
                component: OffreRegionaleComponent,
              },
            ],
          },
          {
            path: ':slugCarto/offre-régionale/:idSite',
            resolve: {
              cartographie: cartographieResolver,
              site: siteResolver,
            },
            component: SélectionOffreRégionaleComponent,
          },
          {
            path: ':slugCarto/référentiels/:slugRef',
            resolve: {
              referentiel: referentielResolver,
              cartographie: cartographieResolver,
            },
            data: {
              roles: ['REFERENTIEL'],
            },
            component: FormLayoutComponent,
            children: [
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'général',
              },
              {
                path: 'général',
                component: RéférentielMétierGénéralComponent,
              },
              {
                path: 'périmètre',
                component: RéférentielMétierPérimètreComponent,
              },
              {
                path: 'processus',
                component: RéférentielMétierProcessusComponent,
              },
              {
                path: 'interrelations',
                component: ReferentielMetierInterrelationsComponent,
              },
              {
                path: 'ressources-professionnelles',
                component: RéférentielMétierRessourcesProfessionnellesComponent,
              },
            ],
          },
          {
            path: ':slugCarto/référentiels/:slugRef/parcours',
            component: ParcoursLayoutComponent,
            resolve: {
              cartographie: cartographieResolver,
              referentiel: referentielResolver,
              //// jalon: jalonResolver,
              finParcours: finParcoursResolver,
              groupeEtapes: groupeÉtapesResolver,
              etape: etapeResolver,
              module: moduleResolver,
            },
            data: {
              roles: ['PARCOURS'],
            },
            runGuardsAndResolvers: 'paramsOrQueryParamsChange',
            children: [
              {
                path: '',
                resolve: {
                  parcours: parcoursResolver,
                },
                component: RéférentielMétierParcoursComponent,
              },
              {
                path: ':idParcours',
                resolve: {
                  parcours: parcoursResolver,
                },
                component: RéférentielMétierParcoursComponent,
              },
            ],
          },
          {
            path: ':slugCarto/référentiels/:slugRef/parcours/:idParcours/modules/:idModule',
            component: ScenarisationLayoutComponent,
            resolve: {
              cartographie: cartographieResolver,
              referentiel: referentielResolver,
              module: moduleResolver,
              scenarisation: scenarisationResolver,
            },
            data: {
              roles: ['SCENARISATION'],
            },
            children: [
              {
                path: '',
                component: SequenceListComponent,
              },
            ],
          },
          {
            path: ':slugCarto/référentiels/:slugRef/parcours/:idParcours/modules/:idModule/sequences/:idSequence/activités',
            resolve: {
              cartographie: cartographieResolver,
              referentiel: referentielResolver,
              module: moduleResolver,
              scenarisation: scenarisationResolver,
              sequence: séquenceResolver,
            },
            children: [
              { path: 'création', component: ActiviteFormComponent },
              {
                path: 'édition/:idActivite',
                resolve: {
                  activite: activiteResolver,
                },
                component: ActiviteFormComponent,
              },
            ],
          },
          {
            path: ':slugCarto/référentiels/:slugRef/parcours/:idParcours/modules/:idModule/sequences/:idSequence/activités/:idActivite',
            resolve: {
              cartographie: cartographieResolver,
              referentiel: referentielResolver,
              module: moduleResolver,
              scenarisation: scenarisationResolver,
              sequence: séquenceResolver,
              activite: activiteResolver,
            },
            component: ActiviteLayoutComponent,
            children: [
              { path: '', redirectTo: 'description', pathMatch: 'full' },
              {
                path: 'description',
                component: ActiviteDescriptionComponent,
              },
              {
                path: 'parcours-objectif',
                component: ActiviteParcoursObjectifComponent,
              },
              {
                path: 'alternatives',
                component: ActiviteAlternativesComponent,
              },
            ],
          },
          {
            path: ':slugCarto/référentiels/:slugRef/croisement',
            component: CroisementLayoutComponent,
            resolve: {
              cartographie: cartographieResolver,
              referentiel: referentielResolver,
            },
            data: {
              roles: ['PARCOURS'],
            },
            children: [
              {
                path: '',
                component: CroisementRéférentielListComponent,
              },
              {
                path: ':codeFiche',
                resolve: {
                  certification: certificationResolver,
                },
                children: [
                  { path: '', component: CroisementRéférentielFormComponent },
                  {
                    path: ':codeBloc',
                    component: BlocCompetencesComponent,
                    resolve: {
                      bloc: blocResolver,
                    },
                    children: [
                      { path: '', component: GestionComponent, canDeactivate: [canDeactivateGuard] },
                      { path: 'aptitudes', component: AptitudesComponent },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'admin',
    // canActivateChild: [AuthGuard, adminGuard],
    component: AdminLayoutComponent,
    children: [
      { path: '', redirectTo: 'cartographies', pathMatch: 'full' },
      {
        path: 'cartographies',
        children: [
          { path: 'gestion', component: CartoListComponent },
          {
            path: ':slugCarto',
            resolve: { cartographie: cartographieResolver },
            children: [
              { path: 'référentiels', component: RéférentielsListComponent },
              { path: 'parcours', component: ParcoursListComponent },
              { path: 'formations-obligatoires-réglementaires', component: FormationObligatoireReglementaireComponent },
              { path: 'modalités', component: ModalitésComponent },
              { path: 'sites', component: GestionSitesComponent },
            ],
          },
        ],
      },
      { path: 'techniques-animation', component: TechniqueAnimationListComponent },
      { path: 'certifications', component: GestionCertificationList },
      { path: 'trigrammes-type-certification', component: GestionTrigrammesTypeCertificationList },
      { path: 'messages-information', component: MessagesInformationComponent },
    ],
  },
  {
    path: 'non-trouvé',
    component: NotFoundComponent,
  },
  {
    path: 'pas-autorisé',
    component: UnauthorizedComponent,
  },
  {
    path: 'accès-restreint',
    component: AccèsRestreintComponent,
  },
  {
    path: '**',
    redirectTo: '/non-trouvé',
  },
];
